import { IDocumentMetadata, IDocumentVersionInfo } from "@multiweb/types/contracts";
import { RequestContext } from "../../../RequestContext";

/**
 * Komunikační klient umožňující načítání informací o dokumentech uložených v aplikaci
 * @includeToDoc
 */
export interface IDocumentClient {
    /**
     * Získá název souboru
     * @param instanceID Instance objektu, ze kterého chceme číst název souboru
     * @param attributeName Název atributu s dokumentem
     * @param requestContext Viz {@link RequestContext}
     */
    getDocumentName(instanceID: string, attributeName: string, requestContext?: RequestContext): Promise<string>;
    /**
     * Získá hash souboru
     * @param instanceID Instance objektu, ve kterém je umístěn soubor
     * @param attributeName Název atributu s dokumentem
     * @param requestContext Viz {@link RequestContext}
     */
    getDocumentHashCode(instanceID: string, attributeName: string, requestContext?: RequestContext): Promise<string>;
    /**
     * Získá metadata souboru
     * @param instanceID Instance objektu, ve kterém je umístěn soubor
     * @param attributeName Název atributu s dokumentem
     * @param requestContext Viz {@link RequestContext}
     */
    getDocumentMetadata(instanceID: string, attributeName: string, requestContext?: RequestContext): Promise<IDocumentMetadata>;
    /**
     * Získá seznam verzí dokumentu
     * @param instanceID Instance objektu, ve kterém je umístěn soubor
     * @param attributeName Název atributu s dokumentem
     * @param requestContext Viz {@link RequestContext}
     */
    getDocumentVersions(instanceID: string, attributeName: string, requestContext?: RequestContext): Promise<IDocumentVersionInfo[]>;
}
